exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox-group[data-v-3205702c] {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n}\n", ""]);

// exports
